﻿export class FileTooLarge {
    constructor(public size: number, public maxSize: number) { }
}